export const ValidateMax = angular
    .module('app.directives.vlnMax', [])
    .directive('vlnMax', ($parse) => {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: (scope, ele, attrs, ngModel) => {
                if (!attrs.vlnMax) {
                    throw new Error('Max attribute required for vln-max');
                }

                ele.on('input', () => {
                    var max = $parse(attrs.vlnMax)(scope);
                    var value = ele.val();
                    value = value.replace(/,/g, '');
                    value = parseFloat(value);
                    if (value > max) {
                        ngModel.$setViewValue(max);
                        ngModel.$render();
                    }
                });

                scope.$watch(attrs.vlnMax, (newVal, oldVal) => {
                    if (newVal !== oldVal) {
                        ngModel.$validate();
                    }
                });

                ngModel.$validators.max = (modelValue) => {
                    var max = $parse(attrs.vlnMax)(scope);

                    if (max != null && modelValue != null && modelValue !== '') {
                        return (modelValue <= max);
                    }

                    return true;
                };
            }
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/directives/validateMax.directive.js